export class PredecessorTask {
    id: string = '';
    name: string = "";
    expectedStart: {year: number, month: number, day: number} = null;
    expectedFinish: {year: number, month: number, day: number} = null;
}